import { t } from "i18next";
import axios from "../../../lib/axios"

const getHourlyRates = async (config, payload) => {
    const url = '/api/hourly-rates/index';

    return await axios
        .post(url, payload, config)
        .then(({ data }) => data)
        .catch(({ response }) => {
            console.error(response)
            return []
        })
}

const saveHourlyRates = async (config, payload) => {
    const url = '/api/hourly-rates/store';

    return await axios
        .post(url, payload, config)
        .then(({ data }) => {
            return {
                status: true,
                message: t('x_successfully_y', {
                    x: t('hourly_rates'),
                    y: t('saved')
                })
            };
        })
        .catch(({ response }) => {
            console.error(response)
            return {
                status: false,
                message: t('could_not_x_y', {
                    x: t('save').toLocaleLowerCase(),
                    y: t('hourly_rates').toLocaleLowerCase()
                })
            };
        })
}

const hourlyRatesAPI = {
    getHourlyRates,
    saveHourlyRates
}

export default hourlyRatesAPI
